
// キャラクター表示
// chara_data は外部jsより取得

if( $('#page-character').length ){
    setup_character();
}


/*********************
* セットアップ
*/
function setup_character() {

    var data = chara_data;
    data.now_index = 0;
    data.show_status = 'init';
    data.is_image_loaded = false;   // 大きい画像のプリロード完了
    data.now_chara_img = 'img/dummy.png';  // 現在の画像

    var chara_vue = new Vue({
        el: '#app-chara',
        data: data,
        computed: {
            now_chara: function () {
                return this.chara_list[this.now_index];
            }
        },
        methods: {
            // キャラ詳細表示
            show_detail: show_detail,
            // 閉じるボタン
            close_detail: close_detail,
            // 戻る、進むボタン
            prev_detail: $.proxy(prev_detail, chara_vue),
            next_detail: $.proxy(next_detail, chara_vue)
        }
    });

    $(window).on('resize', $.throttle( 100, function(){
        $('.chara-popup__visual img').responsify();
    }));

    /*********************
    * 特定IDの画像を取得
    */
    function get_index_image(index) {
        return chara_vue.img + chara_vue.chara_list[index].id + '.jpg';
    }

    /*********************
    * 特定のIDのキャラを表示
    * @this chara_vue
    */
    function show_detail(index) {
        var self = chara_vue;
        var next_index = index;

        // 画像読み込み前の状態
        self.is_image_loaded = false;
        // 番号を入れ替え
        self.now_index = next_index;

        // ポップアップを開く
        self.show_status = 'open';
        $('body').addClass('is-popup');

        // ビジュアルを読み込んだらフェードイン＆自動リサイズ
        var preload = require('../caracol2/util/preload.js');
        preload( [ get_index_image(next_index) ] )
        .done(function (total, count) {
            setTimeout(function () {
                self.now_chara_img = get_index_image(next_index);
                $('.chara-popup__visual img').responsify();
                self.is_image_loaded = true;
            }, 500);
        });
    }

    /*********************
    * 戻るボタン
    * @this chara_vue
    */
    function prev_detail() {
        var index = this.now_index -1  >= 0 ? this.now_index -1 : this.chara_list.length -1;
        show_detail( index );
        return false;
    }

    /*********************
    * 進むボタン
    * @this chara_vue
    */
    function next_detail(){
        var index = (this.now_index +1) % this.chara_list.length;
        show_detail( index );
        return false;
    }

    /*********************
    *閉じる
    * @this chara_vue
    */
    function close_detail() {
        this.is_image_loaded = false;
        this.show_status = "close";
        $('body').removeClass('is-popup');
    }
}
